import { Tooltip, TooltipProps } from "@chakra-ui/react";
import { ReactNode } from "react";

interface CommonTooltipProps extends Omit<TooltipProps, "children"> {
  children: ReactNode;
  label: string;
}

/**
 * Reusable tooltip component with consistent styling
 * Matches the design system used across the application
 */
export const CommonTooltip = ({
  children,
  label,
  hasArrow = true,
  placement = "top",
  bg = "#2D3748",
  color = "white",
  fontSize = "12px",
  borderRadius = "8px",
  px = 3,
  py = 2,
  maxW = "250px",
  ...rest
}: CommonTooltipProps) => {
  return (
    <Tooltip
      label={label}
      hasArrow={hasArrow}
      placement={placement}
      bg={bg}
      color={color}
      fontSize={fontSize}
      borderRadius={borderRadius}
      px={px}
      py={py}
      maxW={maxW}
      {...rest}
    >
      {children}
    </Tooltip>
  );
};
